import React from 'react';
import { Award } from 'lucide-react';

export const CertificationsSection = () => {
  return (
    <section className="py-12 bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-8">
          {/* Certification Title */}
          <div className="flex items-center gap-3">
            <Award className="w-8 h-8 text-blue-900" />
            <h3 className="text-3xl font-bold text-slate-900">
              Certified Quality Management
            </h3>
          </div>

          {/* Description */}
          <div className="max-w-4xl text-center">
            <p className="text-lg text-slate-700 leading-relaxed">
              RHE maintains a certified ISO 9001 Quality Management System, demonstrating our commitment to consistent service delivery, continual improvement, and best-practice project management processes. Our quality framework supports the effective delivery of infrastructure, and government projects, ensuring services are delivered with a strong focus on compliance, accountability, risk management, and client satisfaction.
            </p>
          </div>

          {/* ISO 9001 Logos */}
          <div className="flex items-center gap-8">
            <img
              src="https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/cr2vewxw_ISO%209001edit.png"
              alt="ISO 9001 Certified Management System"
              className="h-24 w-auto object-contain"
            />
            <img
              src="https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/42qsfd61_JASANZ%20RGB%20with%20URL%202026.jpg"
              alt="JAS-ANZ Accredited Certification"
              className="h-24 w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
